import { IQueryContext } from 'framework/context/IQueryContext';
import { IExactOnlineSale, IExactOnlineSalesQueryParams, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const ExactOnlineSalesQueryContext = React.createContext<IQueryContext<IQueryResult<IExactOnlineSale>, IExactOnlineSalesQueryParams>>(undefined as any);
